import { createBUCTheme } from "@braintrust/braintrust-ui-components";

const projectFont = "Graphik, Helvetica, Arial, sans-serif";
export const projectTheme = createBUCTheme({ defaultFontFamily: projectFont });
